import { render } from "./EndangeredCategory.vue?vue&type=template&id=12d9e9a9&scoped=true"
import script from "./EndangeredCategory.vue?vue&type=script&lang=js"
export * from "./EndangeredCategory.vue?vue&type=script&lang=js"

import "./EndangeredCategory.vue?vue&type=style&index=0&id=12d9e9a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d9e9a9"]])

export default __exports__